import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_PermissionGroup } from '@nu-art/permissions-shared';
export const dispatch_onPermissionGroupChanged = new ThunderDispatcherV3('__onPermissionGroupUpdated');
export class ModuleFE_PermissionGroup_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_PermissionGroup, dispatch_onPermissionGroupChanged);
        this._v1 = {};
    }
}
export const ModuleFE_PermissionGroup = new ModuleFE_PermissionGroup_Class();
//# sourceMappingURL=ModuleFE_PermissionGroup.js.map